import React, { Component } from "react";
import fire from '../fire';
import { Accordion, Icon, Header } from "semantic-ui-react";

class YearTwoProgramList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: -1,
      activeIndexSub: -1,
      program:[{days:[]}]
    };
  }

  componentDidMount() {
  
    const yearTwoProgramRef = fire.database().ref('yearTwoProgram');

    yearTwoProgramRef.on('value', snapshot => {
      let program = snapshot.val();
      let newState = [];

      for (let item in program) {
        newState.push({
          id: item,
          weekNumber:program[item].weekNumber,
          weekTitle: program[item].weekTitle,
          weekDescription: program[item].weekDescription,
          days: program[item].days
        });
      }

      this.setState({
        program: newState
      });
    });
  }

  handleClick = (e, { name, index }) => {
    index !== this.state[name] ? this.setState({ [name]: index }) : this.setState({ [name]: -1 });
  }

  render(){
    return(
      <Accordion fluid styled>
        {
          this.state.program.map((program, index) =>
            <div key={index}>
              <Accordion.Title name="activeIndex" active={this.state.activeIndex === index} index={index} onClick={this.handleClick}>
                <Icon name='dropdown' />
                Week {program.weekNumber}
              </Accordion.Title>
              <Accordion.Content active={this.state.activeIndex === index}>
                <Header as="h5" content={program.weekDescription} />
                  {
                    program.days.map((day, index) =>
                      <div key={index}>
                        <Accordion.Title name="activeIndexSub" active={this.state.activeIndexSub === index} index={index} onClick={this.handleClick}>
                          <Icon name='dropdown' />
                          Day {day.dayNumber}
                        </Accordion.Title>
                        <Accordion.Content active={this.state.activeIndexSub === index}>
                          <Header as="h5" content={day.dayDescription} />
                        </Accordion.Content>
                      </div>
                    )
                  }
              </Accordion.Content>
            </div>
          )
        }
      </Accordion>
    );
  }
}
export default YearTwoProgramList;